import React, { useEffect, useState, forwardRef } from 'react';

import {
    Box,
    Divider,
    Typography,
    Paper,
    Button,
    TextField,
    InputAdornment,
    IconButton,
    List,
    ListSubheader,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    ListItem,
    Chip,
    Skeleton,
    FormControl,
    Grid,
    InputLabel,
    Select,
    FormControlLabel,
    FormHelperText,
    MenuItem,
    Switch,
    styled,
    AppBar,
    Toolbar,
    OutlinedInput,
    Checkbox,
    Tooltip
} from '@mui/material';

import { useFormik } from 'formik';
import { spliceString } from "../../../utils/formatString";

import { useAppContextFeatures } from '../../../context/AppContext';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useItems, itemTypes, targetTypes } from '../../../hooks/api/useItems';
import { useCustomFields, customFieldModules, customFieldFunctions } from '../../../hooks/api/useCustomFields';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import CommonSectionHeader from '../../common/CommonSectionHeader';
import { CommonIcons, icons } from '../../common/CommonIcons';
import CommonRestricted from '../../common/CommonRestricted';

import { initialValues, validationSchema, initialValuesRow } from "../../../schema/products/itemSchema";
import { inputTypes, inputTypesDef } from "../../../schema/customFields/customFieldSchema"

import { useStateCustomFields } from "../../../hooks/state/useStateCustomFields";

export default function NewItem(
    {
        routeType,
        productId,
        dataUoms,
        dataSuppliers,
        handleOnSuccess,
    }
) {

    const { promptMessage } = useSystemPrompt()
    const { setSystemLoading } = useAppContextFeatures()
    const { list: listCustomFields } = useCustomFields({ customFieldModule: customFieldModules.item, customFieldFunction: customFieldFunctions.item.item })

    const { create, get: getItem, filterOperatorTypes } = useItems({ itemType: itemTypes.item, targetType: targetTypes.item });
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.item.id)

    const {
        dataCustomFields,

        getInitialFormStateRows,
        getSubmitFormDataFromRows,

        getCustomFieldOptionNameByIds,

        RenderCustomFieldSelectionTextbox,
        RenderCustomFieldSelectionDropdown,
        RenderCustomFieldSelectionMultiDropdown
    } = useStateCustomFields(
        {
            fieldModule: customFieldModules.item,
            moduleFunction: customFieldFunctions.item.item
        }
    )

    const [customFields, setCustomFields] = useState(dataCustomFields)
    const [dataProduct, setDataProduct] = useState()
    const [dataItem, setDataItem] = useState()

    const initialValuesSelected = {
        ...initialValues,
        productId,
        rows: [initialValuesRow]
    }

    const fetchItem = async ({ itemId }) => {

        try {

            const { data } = await getItem({ id: itemId, itemType: itemTypes.item })

            setDataItem(data?.item)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

    }

    const fetchProduct = async ({ productId }) => {

        try {

            const { data } = await getItem({ id: productId, itemType: itemTypes.product })

            setDataProduct(data?.product)

            return data?.product

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        return false;
    }

    const initialFetchData = async () => {

        // get the product
        if (productId) {
            const _dataProduct = await fetchProduct({ productId })

            // console.log('_dataProduct, _dataProduct', _dataProduct);

            if (_dataProduct?.default_uom_item_id) {
                await fetchItem({ itemId: _dataProduct.default_uom_item_id })
            }
        }

    }

    useEffect(() => {

        // get the product
        initialFetchData()

    }, [])

    const loadInitialCustomFieldState = async () => {

        const cf = await getInitialFormStateRows({
            savedCustomFields: []
        })

        setFieldValue(`rows`, cf)
    }

    useEffect(() => {

        loadInitialCustomFieldState()

    }, [])

    const getUom = (id) => {

        if (!id) return ""

        const a = dataUoms.filter(i => i.id === id)
        return a ? a[0].name : ""
    }

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            // geting the custom fields
            const { rows } = values;
            let cf = getSubmitFormDataFromRows({ customFields, rows })

            let data = {
                item: {
                    product_id: currentValues.productId,
                    code: currentValues.code,
                    uom_id: currentValues.uomId,
                    is_package: (currentValues.packageStatus) ? 1 : 0,

                    item_description: currentValues.uomDesc,
                    remark: currentValues.remark,
                    cost: currentValues.cost,
                    uom_price: currentValues.uomPrice,
                    floor_price: currentValues.floorPrice,

                    gross_weight: currentValues.grossWeight,
                    volume_weight: currentValues.volumeWeight,
                    net_weight: currentValues.netWeight,
                    dimension_width: currentValues.width,
                    dimension_height: currentValues.height,

                    dimension_length: currentValues.length,
                    cbm: currentValues.cbm,
                    status: (currentValues.uomStatus) ? 1 : 0,
                },
                props: {
                    transform_ratio: currentValues?.transformRatio,
                    repack_remark: currentValues.repackRemark,
                    supplier_id: currentValues.supplierId,
                    relocate_topup_qty: currentValues.relocateTopUpQty,
                    reorder_topup_qty: currentValues.reorderTopUpQty,
                    relocate_threshold_qty: currentValues.relocateThresholdQty,
                    reorder_threshold_qty: currentValues.reorderThresholdQty,
                },
                custom_fields: cf
            }

            if (cf.length) {
                data.custom_fields = cf
            }

            console.log('data', data)

            const response = await create({ data });

            promptMessage(true, `${response?.message}`)

            if (handleOnSuccess) handleOnSuccess();

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)
    }

    const formik = useFormik({
        initialValues: initialValuesSelected,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = formik;

    const getSupplierOptionNameByIds = (optionIdArray) => {

        if (!optionIdArray) return []

        // customFields.filter(i => i.id === id)

        let optionNames = [];

        dataSuppliers.forEach((e) => {
            // e.options.forEach((e2) => {
            // if(e2.option_key === optionIdArray){
            if (optionIdArray.includes(e.id)) {
                optionNames.push(e.company_name)
            }
            // })
        })

        return optionNames
    }

    const RenderCustomFieldSelection = () => {

        if (!values?.rows) return <></>

        const rows = values.rows

        if (values.rows.length <= 0) return <></>

        return (
            <>
                <Grid item xs={12}>
                    <Divider sx={{ mt: 2, mb: 1 }} />
                </Grid>

                <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                    <CommonSectionHeader
                        title='Custom Properties'
                        subTitle={"Provide custom item information"}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={9}>
                    <List>
                        {
                            rows.map((item, index) => {

                                // const { rows } = values

                                // let itemValues = rows.length ? rows[index] : {}
                                let itemValues = item

                                let {
                                    fieldType,
                                    fieldLabel,
                                    fieldKey
                                } = itemValues

                                return (
                                    <ListItem
                                        key={index}
                                        divider
                                        disablePadding
                                        sx={{
                                            py: 1
                                        }}
                                    >
                                        <Grid container spacing={1}>
                                            <Grid item md={3} xs={12} sm={12} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} >
                                                <Chip
                                                    label={fieldLabel}
                                                    color='primary'
                                                    variant='outlined'
                                                    size='large'
                                                    // avatar={<CommonIcons name={icons.add} />}
                                                    sx={{
                                                        width: '100%',
                                                        // textAlign: 'left',
                                                        fontSize: 16,
                                                        fontWeight: 800
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item md={9} xs={12} sm={12}>

                                                {
                                                    fieldType === inputTypesDef.textbox &&

                                                    RenderCustomFieldSelectionTextbox({
                                                        customFields,
                                                        index,
                                                        item,
                                                        itemValues,
                                                        inputProps: {
                                                            fullWidth: true,
                                                            name: `rows.${index}.customValue`,
                                                            label: itemValues?.fieldLabel,
                                                            type: "text",
                                                            variant: "outlined",
                                                            value: itemValues?.customValue,
                                                            onChange: (event) => setFieldValue(`rows.${index}.customValue`, event.target.value),
                                                        }
                                                    })
                                                }

                                                {
                                                    fieldType === inputTypesDef.dropdown &&

                                                    RenderCustomFieldSelectionDropdown({
                                                        customFields,
                                                        index,
                                                        item,
                                                        itemValues,
                                                        selectProps: {
                                                            labelId: "customValue",
                                                            label: itemValues?.fieldLabel,
                                                            name: `rows.${index}.customArray`,
                                                            onChange: (event) => {
                                                                setFieldValue(`rows.${index}.customArray`, [event.target.value])
                                                            },
                                                            size: 'small',
                                                            margin: 'dense',
                                                            value: itemValues.customArray.length ? itemValues.customArray[0] : ""
                                                        }
                                                    })
                                                }


                                                {
                                                    fieldType === inputTypesDef.multidropdown &&

                                                    RenderCustomFieldSelectionMultiDropdown({
                                                        customFields,
                                                        index,
                                                        item,
                                                        itemValues,
                                                        selectProps: {
                                                            labelId: itemValues?.fieldLabel,
                                                            label: itemValues?.fieldLabel,
                                                            name: `rows.${index}.customArray`,
                                                            onChange: handleChange,
                                                            renderValue: (selected) => {

                                                                return (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                                        {
                                                                            getCustomFieldOptionNameByIds(selected, dataCustomFields, fieldKey).map((i, index) => (
                                                                                <Chip
                                                                                    key={index}
                                                                                    // color={'red'}
                                                                                    label={spliceString({ val: i, maxLength: 20 })}
                                                                                />
                                                                            ))
                                                                        }
                                                                    </Box>
                                                                )

                                                            },
                                                            size: 'small',
                                                            margin: 'dense',
                                                            multiple: true,
                                                            input: <OutlinedInput id="select-multiple-chip" label="Chip" />,
                                                            value: itemValues?.customArray ? itemValues.customArray : []
                                                        }
                                                    })
                                                }

                                            </Grid>
                                        </Grid>
                                    </ListItem>
                                )

                            })
                        }

                    </List>

                </Grid>
            </>
        )
    }

    const RenderTransformRatio = () => {

        if (!dataProduct) return <></>
        if (!dataItem) return <></>

        // check this item is default
        // const {
        //     default_uom_item_id: defaultItemId
        // } = dataProduct

        if (!values?.uomId) {
            return (
                <>
                    <Grid item xs={12}>
                        <Divider sx={{ mt: 2, mb: 1 }} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                        <CommonSectionHeader
                            title='Transform Uom'
                            subTitle={"Conversion ratio between Uoms"}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={9}>
                        <Grid container spacing={0.5}>
                            <Grid item xs={6} md={6} sm={6} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Chip
                                    label={`No Uom Selected`}
                                    sx={{
                                        mt: 1
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            )
        }

        const {
            uom_name: defaultUomName
        } = dataItem

        // const isDefault = false; // (id === defaultItemId)

        return (
            <>
                <Grid item xs={12}>
                    <Divider sx={{ mt: 2, mb: 1 }} />
                </Grid>
                <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                    <CommonSectionHeader
                        title='Transform Uom'
                        subTitle={"Conversion ratio between Uoms"}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={9}>
                    {/* {
                        isDefault?
                        (
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={3} sm={4}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"transformRatio"}
                                        label="Transform Ratio"
                                        type="text"                                         
                                        variant="outlined"
                                        value={values.transformRatio}
                                        // onChange={handleChange}
                                        disabled
                                        // error={touched.transformRatio && Boolean(errors.transformRatio)}
                                        // helperText={touched.transformRatio && errors.transformRatio}
                                    />
                                </Grid> 
                                <Grid item xs={12} md={9} sm={8} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                    <Chip
                                        label={`Marked as Default Uom, Transform ratio must be 1`}
                                        variant='contained'
                                        size="large"
                                        color={"warning"}
                                    />
                                </Grid>
                            </Grid>
                        )
                        :
                        ( */}
                    <Grid container spacing={0.5}>
                        <Grid item xs={6} md={3} sm={6} display={"flex"} justifyContent={"center"} alignItems={"center"}>


                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                // name={"transformRatio"}
                                label="Current"
                                type="text"
                                variant="outlined"
                                value={`1`}
                                // onChange={handleChange}
                                // error={touched.transformRatio && Boolean(errors.transformRatio)}
                                // helperText={touched.transformRatio && errors.transformRatio}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment
                                            position="end"
                                        >
                                            / {getUom(values?.uomId)}
                                        </InputAdornment>
                                }}
                                disabled
                            />

                        </Grid>
                        <Grid item xs={6} md={1} sm={6} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <CommonIcons name={icons.equal} sx={{ width: 25, height: 25 }} />
                        </Grid>
                        <Grid item xs={6} md={3} sm={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"transformRatio"}
                                label="Conversion"
                                type="text"
                                variant="outlined"
                                value={values.transformRatio}
                                onChange={handleChange}
                                error={touched.transformRatio && Boolean(errors.transformRatio)}
                                helperText={touched.transformRatio && errors.transformRatio}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment
                                            position="end"
                                        >
                                            / {defaultUomName}
                                        </InputAdornment>
                                }}
                            />
                        </Grid>
                    </Grid>
                    {/* )
                    } */}

                </Grid>
            </>
        )
    }

    const RenderTresholdControl = () => {
        return (

            <Grid container spacing={0.5}>
                <Grid item xs={12}>
                    <Divider sx={{ mt: 2, mb: 1 }} />
                </Grid>

                <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                    <CommonSectionHeader
                        title='Threshold Control'
                        subTitle={"Set qty of threshold level"}
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={9}>
                    <Grid container spacing={0.5}>

                        <Grid item xs={12} sm={12} md={3} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} >
                            <Chip
                                label={"Reorder"}
                                color='primary'
                                variant='outlined'
                                size='large'
                                sx={{
                                    width: '100%',
                                    // textAlign: 'left',
                                    fontSize: 16,
                                    fontWeight: 800
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4.5}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"reorderThresholdQty"}
                                label="Threshold Qty"
                                type="text"
                                variant="outlined"
                                value={values.reorderThresholdQty}
                                onChange={handleChange}
                                error={touched.reorderThresholdQty && Boolean(errors.reorderThresholdQty)}
                                helperText={touched.reorderThresholdQty && errors.reorderThresholdQty}

                                InputProps={{
                                    sx: {
                                        pr: 0.5
                                    },
                                    endAdornment:
                                        <InputAdornment
                                            position="end"
                                        >
                                            <Tooltip
                                                title={`Action perform when threshold qty reach`}
                                            >
                                                <IconButton>
                                                    <CommonIcons name={icons.info} />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4.5}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"reorderTopUpQty"}
                                label="Topup Qty"
                                type="text"
                                variant="outlined"
                                value={values.reorderTopUpQty}
                                onChange={handleChange}
                                error={touched.reorderTopUpQty && Boolean(errors.reorderTopUpQty)}
                                helperText={touched.reorderTopUpQty && errors.reorderTopUpQty}

                                InputProps={{
                                    sx: {
                                        pr: 0.5
                                    },
                                    endAdornment:
                                        <InputAdornment
                                            position="end"
                                        >
                                            <Tooltip
                                                title={`Suggestion qty to topup when threshold qty reach`}
                                            >
                                                <IconButton>
                                                    <CommonIcons name={icons.info} />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} >
                            <Chip
                                label={"Relocate"}
                                color='primary'
                                variant='outlined'
                                size='large'
                                sx={{
                                    width: '100%',
                                    // textAlign: 'left',
                                    fontSize: 16,
                                    fontWeight: 800
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={4.5}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"relocateThresholdQty"}
                                label="Threshold Qty"
                                type="text"
                                variant="outlined"
                                value={values.relocateThresholdQty}
                                onChange={handleChange}
                                error={touched.relocateThresholdQty && Boolean(errors.relocateThresholdQty)}
                                helperText={touched.relocateThresholdQty && errors.relocateThresholdQty}

                                InputProps={{
                                    sx: {
                                        pr: 0.5
                                    },
                                    endAdornment:
                                        <InputAdornment
                                            position="end"
                                        >
                                            <Tooltip
                                                title={`Action perform when threshold qty reach`}
                                            >
                                                <IconButton>
                                                    <CommonIcons name={icons.info} />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4.5}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"relocateTopUpQty"}
                                label="Topup Qty"
                                type="text"
                                variant="outlined"
                                value={values.relocateTopUpQty}
                                onChange={handleChange}
                                error={touched.relocateTopUpQty && Boolean(errors.relocateTopUpQty)}
                                helperText={touched.relocateTopUpQty && errors.relocateTopUpQty}

                                InputProps={{
                                    sx: {
                                        pr: 0.5
                                    },
                                    endAdornment:
                                        <InputAdornment
                                            position="end"
                                        >
                                            <Tooltip
                                                title={`Suggestion qty to topup when threshold qty reach`}
                                            >
                                                <IconButton>
                                                    <CommonIcons name={icons.info} />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    const RenderForm = () => {
        return (

            <Box
                sx={{
                    // p: 3,
                    // pt: 0,
                    // maxHeight: 800,
                }}
            >
                <Grid container>
                    <Grid item xs={12} sm={12} md={3} textAlign={"left"}>

                        <CommonSectionHeader
                            title='Information'
                            subTitle={"Provide the default items of the product"}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12} md={9}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={6}>

                                <FormControl
                                    margin="dense"
                                    fullWidth
                                    size="small"
                                    error={touched.uomId && Boolean(errors.uomId)}
                                >
                                    <InputLabel id="uomId">Uom</InputLabel>
                                    <Select
                                        labelId="uomId"
                                        label="Uom"
                                        name={"uomId"}
                                        onChange={handleChange}
                                        value={values.uomId}
                                        sx={{
                                            textAlign: 'left'
                                        }}
                                    >
                                        {
                                            dataUoms && dataUoms.map((item, index) =>
                                                <MenuItem key={index} value={item?.id}>{item.name}</MenuItem>
                                            )
                                        }
                                    </Select>
                                    <FormHelperText>
                                        {touched.uomId && errors.uomId}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid item xs={6} sm={6} md={3}
                                sx={{
                                    display: 'center',
                                }}>
                                <FormControlLabel
                                    sx={{
                                        marginLeft: '1px',
                                        my: 1
                                    }}
                                    control={
                                        <Switch
                                            name="uomStatus"
                                            checked={Boolean(values.uomStatus)}
                                            onChange={(event, checked) => {
                                                setFieldValue("uomStatus", checked);
                                            }}
                                        />
                                    }
                                    label={
                                        Boolean(values.uomStatus) ? "Enabled" : "Disabled"
                                    }
                                />
                            </Grid>

                            {/* <Grid item xs={6} sm={6} md={3}
                                sx={{
                                    display:'center',
                                }}>  
                                <FormControlLabel 
                                    sx={{
                                        marginLeft:'1px'
                                    }}
                                    control={
                                        <Switch 
                                            name="packageStatus" 
                                            checked={Boolean(values.packageStatus)}
                                            onChange={(event, checked) => {
                                                setFieldValue("packageStatus", checked);
                                            }}
                                        />
                                    }     
                                    label={
                                        Boolean(values.packageStatus)? "Is Package" : "Not Package"
                                    }
                                />
                            </Grid> */}

                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"code"}
                                    label="Code"
                                    type="text"
                                    variant="outlined"
                                    value={values.code}
                                    onChange={handleChange}
                                    error={touched.code && Boolean(errors.code)}
                                    helperText={touched.code && errors.code}

                                    InputProps={{
                                        sx: {
                                            pr: 0.5
                                        },
                                        endAdornment:
                                            <InputAdornment
                                                position="end"
                                            >
                                                <Tooltip
                                                    title={`Unique Identifier`}
                                                >
                                                    <IconButton>
                                                        <CommonIcons name={icons.info} />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                    }}
                                />
                            </Grid>

                            {/* <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"displayCode"}
                                    label="Display Code"
                                    type="text"                                         
                                    variant="outlined"
                                    value={values.displayCode}
                                    onChange={handleChange}
                                    error={touched.displayCode && Boolean(errors.displayCode)}
                                    helperText={touched.displayCode && errors.displayCode}
                                />
                            </Grid> */}

                            <Grid item xs={12} sm={12} md={6}>
                                <FormControl
                                    margin="dense"
                                    fullWidth
                                    size="small"
                                    error={touched.supplierId && Boolean(errors.supplierId)}
                                >
                                    <InputLabel id="supplierId">Supplier</InputLabel>

                                    <Select
                                        labelId="supplierId"
                                        label="Supplier"
                                        name={"supplierId"}
                                        onChange={(event) => {
                                            setFieldValue("supplierId", event.target.value)
                                        }}
                                        // value={values.supplierId}
                                        value={values.supplierId.length ? values.supplierId : []}
                                        // sx={{
                                        //     textAlign: 'left'
                                        // }}
                                        renderValue={(selected) => {

                                            return (
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                    {
                                                        getSupplierOptionNameByIds(selected).map((i, index) => (
                                                            <Chip
                                                                key={index}
                                                                // color={'red'}
                                                                label={spliceString({ val: i, maxLength: 20 })}
                                                            />
                                                        ))
                                                    }
                                                </Box>
                                            )

                                        }}
                                        multiple
                                        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                    >
                                        {
                                            dataSuppliers?.map((i, index) => {
                                                return (
                                                    <MenuItem
                                                        key={index}
                                                        value={i?.id}
                                                    >
                                                        <Checkbox checked={values.supplierId.indexOf(i?.id) > -1} />
                                                        <ListItemText
                                                            primary={`${i.company_name}`}
                                                        />
                                                    </MenuItem>
                                                )
                                            })
                                        }

                                    </Select>
                                    <FormHelperText>
                                        {touched.supplierId && errors.supplierId}
                                    </FormHelperText>

                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"uomDesc"}
                                    label="Description"
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.uomDesc}
                                    onChange={handleChange}
                                    error={touched.uomDesc && Boolean(errors.uomDesc)}
                                    helperText={touched.uomDesc && errors.uomDesc}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label="Remark"
                                    type="text"
                                    variant="outlined"
                                    value={values.remark}
                                    multiline
                                    rows={3}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"repackRemark"}
                                    label="Repack Remark"
                                    type="text"
                                    variant="outlined"
                                    value={values.repackRemark}
                                    multiline
                                    rows={3}
                                    onChange={handleChange}
                                    error={touched.repackRemark && Boolean(errors.repackRemark)}
                                    helperText={touched.repackRemark && errors.repackRemark}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider sx={{ mt: 1, mb: 1 }} />
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} textAlign={"left"}>

                        <CommonSectionHeader
                            title='Measurement &amp; Pricing'
                            subTitle={"Provide detail item information"}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={9}>
                        <Grid container spacing={0.5}>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"cost"}
                                    label="Cost Price"
                                    type="number"
                                    variant="outlined"
                                    value={values.cost}
                                    onChange={handleChange}
                                    error={touched.cost && Boolean(errors.cost)}
                                    helperText={touched.cost && errors.cost}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"uomPrice"}
                                    label="UOM Price"
                                    type="number"
                                    variant="outlined"
                                    value={values.uomPrice}
                                    onChange={handleChange}
                                    error={touched.uomPrice && Boolean(errors.uomPrice)}
                                    helperText={touched.uomPrice && errors.uomPrice}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"floorPrice"}
                                    label="Floor Price"
                                    type="number"
                                    variant="outlined"
                                    value={values.floorPrice}
                                    onChange={handleChange}
                                    error={touched.floorPrice && Boolean(errors.floorPrice)}
                                    helperText={touched.floorPrice && errors.floorPrice}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"volumeWeight"}
                                    label="Volume Weight"
                                    type="text"
                                    variant="outlined"
                                    value={values.volumeWeight}
                                    onChange={handleChange}
                                    error={touched.volumeWeight && Boolean(errors.volumeWeight)}
                                    helperText={touched.volumeWeight && errors.volumeWeight}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"grossWeight"}
                                    label="Gross Weight"
                                    type="number"
                                    variant="outlined"
                                    value={values.grossWeight}
                                    onChange={handleChange}
                                    error={touched.grossWeight && Boolean(errors.grossWeight)}
                                    helperText={touched.grossWeight && errors.grossWeight}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"netWeight"}
                                    label="Net Weight"
                                    type="number"
                                    variant="outlined"
                                    value={values.netWeight}
                                    onChange={handleChange}
                                    error={touched.netWeight && Boolean(errors.netWeight)}
                                    helperText={touched.netWeight && errors.netWeight}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} sm={12}>
                                <Grid
                                    container
                                    spacing={0.5}
                                    sx={{
                                        display: 'flex'
                                    }}
                                >
                                    <Grid item xs={4} sm={4} md={4}>
                                        <TextField
                                            margin="dense"
                                            size="small"
                                            fullWidth
                                            name={"width"}
                                            label="Width"
                                            type="text"
                                            variant="outlined"
                                            value={values.width}
                                            onChange={handleChange}
                                            error={touched.width && Boolean(errors.width)}
                                            helperText={touched.width && errors.width}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment
                                                        position="end"
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 800,
                                                                color: 'black'
                                                            }}
                                                        >W</Typography>
                                                    </InputAdornment>
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4}>
                                        <TextField
                                            margin="dense"
                                            size="small"
                                            fullWidth
                                            name={"height"}
                                            label="Height"
                                            type="text"
                                            variant="outlined"
                                            value={values.height}
                                            onChange={handleChange}
                                            error={touched.height && Boolean(errors.height)}
                                            helperText={touched.height && errors.height}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment
                                                        position="end"
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 800,
                                                                color: 'black'
                                                            }}
                                                        >H</Typography>
                                                    </InputAdornment>
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4}>
                                        <TextField
                                            margin="dense"
                                            size="small"
                                            fullWidth
                                            name={"length"}
                                            label="Length"
                                            type="text"
                                            variant="outlined"
                                            value={values.length}
                                            onChange={handleChange}
                                            error={touched.length && Boolean(errors.length)}
                                            helperText={touched.length && errors.length}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment
                                                        position="end"
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 800,
                                                                color: 'black'
                                                            }}
                                                        >L</Typography>
                                                    </InputAdornment>
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={6} md={6} sm={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"cbm"}
                                    label="CBM"
                                    type="text"
                                    variant="outlined"
                                    value={values.cbm}
                                    onChange={handleChange}
                                    error={touched.cbm && Boolean(errors.cbm)}
                                    helperText={touched.cbm && errors.cbm}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    {
                        RenderTresholdControl()
                    }

                    {
                        RenderTransformRatio()
                    }

                    {
                        RenderCustomFieldSelection()
                    }

                </Grid>
            </Box>

        )
    }

    const RenderMain = () => {
        return (
            <form
                onSubmit={handleSubmit}
                style={{
                    height: '100%'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: '100%',
                        p: 3
                        // alignItems: 'center'
                    }}
                >
                    <Box>
                        {
                            RenderForm()
                        }
                    </Box>

                    <Box
                        sx={{
                            my: 2,
                            textAlign: 'right'
                        }}
                    >
                        <Button
                            variant='contained'
                            // color='inherit'
                            type='submit'
                        >
                            Save Changes
                        </Button>
                    </Box>

                </Box>

            </form>
        )

    }

    return (
        <Box
            sx={{
                height: '100%'
            }}
        >

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderMain()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}